{
  var swiper = new Swiper(".mySliderSwiper", {
    slidesPerView: 9,
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      200: {
        slidesPerView: 4,
      },
      640: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 7,
      },
      1024: {
        slidesPerView: 9,
      },
    },
  });
}

{
  var swiper = new Swiper(".brandSwiper", {
    slidesPerView: 9,
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      200: {
        slidesPerView: 4,
      },
      640: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 7,
      },
      1024: {
        slidesPerView: 9,
      },
    },
  });
}

// {
//   function mobileOnlySlider($slidername, $breakpoint) {
//     var slider = $($slidername);
//     var settings = {
//       slidesToShow: 6,
//       mobileFirst: true,
//       centerMode: false,
//       autoplay: true,
//       autoplaySpeed: 2000,
//       dots: false,
//       arrows: false,
//       responsive: [
//         {
//           breakpoint: $breakpoint,
//           settings: "unslick",
//         },
//         {
//           breakpoint: 1024,
//           settings: "unslick",
//         },
//         {
//           breakpoint: 800,
//           settings: {
//             slidesToShow: 7,
//             slidesToScroll: 1,
//             spaceBetween: 20,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 6,
//             slidesToScroll: 1,
//             spaceBetween: 20,
//           },
//         },
//         {
//           breakpoint: 400,
//           settings: {
//             slidesToShow: 5,
//             slidesToScroll: 1,
//             spaceBetween: 20,
//           },
//         },
//         {
//           breakpoint: 200,
//           settings: {
//             slidesToShow: 5,
//             slidesToScroll: 1,
//             spaceBetween: 20,
//           },
//         },
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 9,
//             slidesToScroll: 1,
//             spaceBetween: 20,
//           },
//         },
//       ],
//     };
//     slider.slick(settings);
//     $(window).on("resize", function () {
//       if ($(window).width() > $breakpoint) {
//         return;
//       }
//       if (!slider.hasClass("slick-initialized")) {
//         return slider.slick(settings);
//       }
//     });
//   }
//   mobileOnlySlider(".mySlider", 1024);
// }

{
  function mobileOnlySlider($slidername, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick",
        },
        {
          breakpoint: 1024,
          settings: "unslick",
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
        {
          breakpoint: 200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
      ],
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider

  mobileOnlySlider(".mySliderTwo", 768);
}

{
  function mobileOnlySlider($slidername, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      slidesToShow: 1,
      mobileFirst: true,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick",
        },
        {
          breakpoint: 1024,
          settings: "unslick",
        },
        {
          breakpoint: 200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider
  mobileOnlySlider(".mySliderThree", 768);
}


const MultipleSlider = () => {
  let MultipleSliders = document.querySelectorAll(".swiperCus");
  let prevArrow = document.querySelectorAll(".prev");
  let nextArrow = document.querySelectorAll(".next");
  MultipleSliders.forEach((slider, index) => {
    let sliderLength = slider.children[0].children.length;
    let result = sliderLength > 1 ? false : true;
    const swiper = new Swiper(slider, {
      direction: "horizontal",
      loop: result,
      // scrollbar: {
      //   el: ".swiper-scrollbar",
      //   hide: true,
      // },
      navigation: {
        nextEl: nextArrow[index],
        prevEl: prevArrow[index],
      },
      breakpoints: {
        200: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 3.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 4.3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      speed: 800,
    });
  });
};



window.addEventListener("load", MultipleSlider);

{
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: false,
    autoplaySpeed: 3000,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".nextCUs",
      prevEl: ".PrevCUs",
    },
  });
}

{
  // function toggleDropdown(dropdownId) {
  //   var dropdown = document.getElementById(dropdownId);
  //   dropdown.classList.toggle("active");
  // }

  function toggleDropdown(element) {
    var dropdownContent = element.nextElementSibling;
    dropdownContent.classList.toggle("active");
  }
}

// Single Product page Tabs

const tabsNav = document.querySelectorAll(".prod-tab-btns li");
const tabsContent = document.querySelectorAll(".prod-tab-content");

tabsNav.forEach((items, ind) => {
  items.addEventListener("click", () => {
    tabsNav.forEach((remove) => {
      remove.classList.remove("active");
    });

    items.classList.add("active");

    tabsContent.forEach((content) => {
      content.classList.remove("active");
    });

    tabsContent[ind].classList.add("active");
  });
});

window.addEventListener("load", () => {
  const mainUl = document.querySelectorAll(
    ".collection-filter-content .accordion-item>.accordion-header"
  );
  const mainContent = document.querySelectorAll(
    ".collection-filter-content .accordion-item>.accordion-content"
  );

  mainUl.forEach((item, ind) => {
    item.addEventListener("click", () => {
      mainContent[ind].classList.toggle("active");
    });
  });

  const subUl = document.querySelectorAll(
    ".sub-accordion .sub-accordion-item .sub-accordion-header"
  );
  const subContent = document.querySelectorAll(
    ".sub-accordion .sub-accordion-item>.accordion-content"
  );

  subUl.forEach((item, ind) => {
    item.addEventListener("click", () => {
      subContent[ind].classList.toggle("active");
    });
  });

  const siteDetails = document.querySelectorAll(
    "details.facets__disclosure-vertical"
  );

  siteDetails.forEach((item) => {
    item.setAttribute("open", true);
  });
});

// window.addEventListener("load", () => {
//   const sort = document.querySelector(".mobile-sorting");
//   const sortSide = document.querySelector(".sort-drawer");
//   const closeSortSide = document.querySelector(".sortClose");

//   sort.addEventListener("click", () => {
//     sortSide.classList.add("active");
//   });

//   closeSortSide.addEventListener("click", () => {
//     sortSide.classList.remove("active");
//   });
// });

// NEW SORTING CODE
window.addEventListener("load", () => {
  const sort = document.querySelector(".mobile-sorting");
  const sortSide = document.querySelector(".mobile-sort-wrapper");
  const closeSortSide = document.querySelector(".mobile-facets__close");

  const hasSortActive = document.querySelector(".mobile-facets__main");

  sort.addEventListener("click", () => {
    sortSide.classList.add("active");
    hasSortActive.classList.add("active-sorting");
  });

  closeSortSide.addEventListener("click", () => {
    sortSide.classList.remove("active");
    hasSortActive.classList.remove("active-sorting");
  });
});

window.addEventListener("load", () => {
  const megaMenu = document.querySelectorAll(".MegaLEft>ul>li");
  megaMenu[0].classList.add("active");

  megaMenu.forEach((items, ind) => {
    items.addEventListener("click", () => {
      megaMenu.forEach((remove) => {
        remove.classList.remove("active");
      });

      items.classList.add("active");
    });
  });
});

// View More And View Less

{
  document.querySelectorAll(".pergraphMoreShow").forEach((paragraph) => {
    const maxLength = 200;
    const originalText = paragraph.innerHTML;
    if (originalText.length > maxLength) {
      const truncatedText = originalText.slice(0, maxLength);
      const remainingText = originalText.slice(maxLength);
      const showMoreLink = document.createElement("a");
      showMoreLink.textContent = " Read More";
      showMoreLink.classList.add("view-more");
      paragraph.innerHTML = truncatedText;
      paragraph.appendChild(showMoreLink);
      showMoreLink.addEventListener("click", () => {
        paragraph.innerHTML = originalText;
        showMoreLink.style.display = "none";
      });
    }
  });
}

// FAQ Start

{
  (function ($) {
    $.fn.extend({
      mAccord: function (options) {
        var defaults = {};
        var options = $.extend(defaults, options);

        return this.each(function () {
          var o = options,
            // container = $(this).find(".accordion-container"),
            trigger = $(this).find(".accordion h3"),
            content = $(this).find(".accordion-content"),
            obj = $(trigger).prev();
          $(".accordion-container .accordion:nth-child(1) h3").addClass(
            "active"
          );
          $(".accordion-container .accordion:nth-child(1) h3")
            .next()
            .slideDown(500);
          trigger.click(function (e) {
            e.stopPropagation();
            var target = $(this).next();

            $(this).addClass("active"),
              trigger.not(this).removeClass("active"),
              target.stop().delay().slideDown(500);

            if (target.is(":visible")) {
              $(this).removeClass("active"), target.stop().slideUp();
            } else if (content.not(target).is(":visible")) {
              $(content.not(target)).stop().slideUp(500);
            }
          });
        });
      },
    });
  })(jQuery);

  (function ($) {
    $(".accordion-container").mAccord();
  })(jQuery);
}

document.addEventListener("DOMContentLoaded", () => {
  const address = document.querySelector(
    '.addresses button[aria-controls="AddAddress"]'
  );

  address.addEventListener("click", () => {
    const currentExpanded = address.getAttribute("aria-expanded");
    const newExpanded = currentExpanded === "true" ? "false" : "true";
    address.setAttribute("aria-expanded", newExpanded);
  });
});


// Edit Address Start


const addressEdit = document.querySelectorAll(
  "body.addresses .customer.addresses ul li button[aria-label^=Edit]"
);

addressEdit.forEach((item) => {
  item.addEventListener("click", () => {
    const currentExpanded = item.getAttribute("aria-expanded");
    const newExpanded = currentExpanded === "true" ? "false" : "true";
    item.setAttribute("aria-expanded", newExpanded);
  });
});


// Mega menu mobile start

document.addEventListener("DOMContentLoaded", () => {
  const allSlideData = document.querySelectorAll(
    ".AllCategorySLide .swiper-slide a"
  );
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;

  if (viewportWidth <= 900) {
    allSlideData.forEach((slideData) => {
      slideData.setAttribute("href", "javascript:;");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var slideLinks = document.querySelectorAll(
    ".AllCategorySLide .swiper .swiper-wrapper .swiper-slide>a"
  );

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;

  if (viewportWidth <= 900) {
    slideLinks.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault(); 
        slideLinks.forEach((link) => {
          if (link !== item && link.classList.contains("activeSlide")) {
            link.classList.remove("activeSlide");
          }
        });
        item.classList.toggle("activeSlide");
      });
    });
  }
});

var liElements = document.querySelectorAll(".AllCategorySLide li.swiper-slide");
for (var i = 4; i < liElements.length; i++) {
  var megaMenuTowElement = liElements[i].querySelector(".megaMenuTow");
  if (megaMenuTowElement) {
    megaMenuTowElement.style.right = "0";
    megaMenuTowElement.style.left = "initial";
  }
}

// loader script

// window.addEventListener("load", function () {
  
//   var loader = document.querySelector(".page-loader");
//   if (loader !== null) {
//     loader.style.transition = "opacity 0.5s";
//     loader.style.opacity = "0";
//     setTimeout(function () {
//       loader.style.display = "none";
//     }, 500);
//   }
 
// });


// Compare page 
window.addEventListener("load", function () {
const comparetitle = document.querySelector('#ldt-app-proxy-root .ldt-cp-text-4xl')
console.log(comparePage)


const box = document.querySelectorAll('.ldt-cp-divide-y tr th[scope="col"]')
console.log(box.length)

});

// Swiper sec loader

// function toggleDisplay() {
//     var elements = document.querySelectorAll('.LowPrice__grid__check');
//     elements.forEach(function (element) {
//         if (element.style.display === 'none') {
//             element.style.display = 'block';

//         } else {
//             element.style.display = 'block';
//         }
//     });
// }

// window.onload = function () {
//     setTimeout(toggleDisplay, 250);
// };

 
